export default "__VITE_ASSET__b9R21l4w__"